import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { LandingComponent } from './landing/landing.component';
import { SimpleLayoutComponent } from './layouts/simple-layout/simple-layout.component';
import { FullLayoutComponent } from './layouts/full-layout/full-layout.component';
import { AuthGuard } from './shared/auth.guard';
import { BrowserUtils } from '@azure/msal-browser';

const routes: Routes = [
  {
    path: '',
    component: SimpleLayoutComponent,
    children: [
      { path: '', component: LandingComponent, pathMatch: 'full' }
    ]
  },
  {
    path: '',
    component: FullLayoutComponent,
    children: [
      {
        path: 'home',
        component: HomeComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'data-collections',
        loadChildren: () => import('./collections/collections.module').then(m => m.CollectionsModule),
        canLoad: [AuthGuard],
        canActivateChild: [AuthGuard]
      },
      {
        path: 'data-utilization',
        loadChildren: () => import('./requests/requests.module').then(m => m.RequestsModule),
        canLoad: [AuthGuard],
        canActivateChild: [AuthGuard]
      },
      {
        path: 'data-uploads',
        loadChildren: () => import('./uploads/uploads.module').then(m => m.UploadsModule),
        canLoad: [AuthGuard],
        canActivateChild: [AuthGuard]
      },
      {
        path: 'terms-of-use',
        loadChildren: () => import('./terms-of-use/terms-of-use.module').then(m => m.TermsOfUseModule),
        canLoad: [AuthGuard],
        canActivateChild: [AuthGuard]
      },
      {
        path: 'app-info',
        loadChildren: () => import('./app-info/app-info.module').then(m => m.AppInfoModule),
        canLoad: [AuthGuard],
        canActivateChild: [AuthGuard]
      },
      {
        path: 'virtual-env',
        loadChildren: () => import('./virtualenv/virtualenv.module').then(m => m.VirtualEnvModule),
        canLoad: [AuthGuard],
        canActivateChild: [AuthGuard]
      }
    ]
  },
  { path: '**', redirectTo: '' }

];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
      useHash: false,
      initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? undefined : 'disabled'
    })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
